import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { getAllTransactions } from "../../../store/constructs/transactions/selectors";
import { getClusterlets } from "../../../store/constructs/clusterlets/selectors";
import { getRoutingRules } from "../../../store/constructs/routing_rules/selectors";
import { getUserTriggers } from "../../../store/constructs/user_triggers/selectors";
import { checkClusterletInTransactions, deleteNodeAndAssociates } from "../../../store/constructs/clusterlets/actions";
import { getInstances } from "../../../store/constructs/bootloaders/selectors";
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import Dialog from "../../atoms/dialog";

const NodeDeletePopUp = (props) => {
  // console.log("props", props)

  const { onClose, id, onCompletion } = props

  const transactions = useSelector(getAllTransactions);
  const rrdefs = useSelector(getRoutingRules);
  const userTriggers = useSelector(getUserTriggers);
  const instances = useSelector(getInstances);
  const clusterletsInStore = useSelector(getClusterlets);
  const clusterlet = clusterletsInStore.find(clusterlet => clusterlet.id === id)
  const dispatch = useDispatch();

  const clusterletInTransation = checkClusterletInTransactions({ id: id, transactions })

  const associatedRrdefs = rrdefs?.filter(rrdef => rrdef.attributes.delegate === id || rrdef.attributes.ttype === id)

  const instanceOfSelectedNode = instances?.find(instance => instance.attributes.type === id)

  const associatedUserTriggers = userTriggers?.filter(ut => {
    if (ut?.attributes?.instance && ut.attributes.instance === instanceOfSelectedNode?.id) return ut
  })

  // console.log({clusterletInTransation, associatedRrdefs, associatedUserTriggers})

  let associatedItems = []

  clusterletInTransation?.forEach(element => {
    associatedItems.push(`Transaction ${element}`)
  });

  associatedRrdefs?.forEach(element => {
    associatedItems.push(`Routing Rule Definition ${element.name}`)
  });

  associatedUserTriggers?.forEach(element => {
    associatedItems.push(`User Trigger ${element.name}`)
  });

  // console.log({associatedItems})

  const onActionComplete = async () => {

    onClose(false);

    await dispatch(deleteNodeAndAssociates({ node: clusterlet }))

    if (onCompletion) await onCompletion();

  };

  return (
    <Dialog
      title={"Delete!"}
      handleClose={() => onClose(false)}
      open={true}
      actions={
        <>
          <DeleteCancel onCancel={() => onClose(false)} onDelete={onActionComplete} />
        </>
      }
    >
      <Fragment>
        <Typography> Deleting this node will delete the following entities </Typography>
      </Fragment>

      <ol>
        {associatedItems.map((item, index) =>
          <li key={index}>  {item} </li>
        )}
      </ol>

      <Fragment>
        <Typography> Do you want to delete? </Typography>
      </Fragment>

    </Dialog>
  );
};

export default NodeDeletePopUp